import { ICreateFornecedorDocumentoUseCase } from "../../../presentation/useCases/create/create_fornecedor_documento_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateFornecedorDocumentoUseCase
 */

export class CreateFornecedorDocumentoUseCase implements ICreateFornecedorDocumentoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createFornecedorDocumento(
    idFornecedor: number,
    statusArquivo: number,
    nomeDocumento: string,
    dataVencimento: Date | null,
    arquivo: File | null,
  ): Promise<void> {
    await this.repository.createFornecedorDocumento(
      idFornecedor,
      statusArquivo,
      nomeDocumento,
      dataVencimento,
      arquivo,
    );
  }
}
